import { t } from '@lingui/macro'
import { format } from 'date-fns'
import { useMemo } from 'react'
import { useTheme } from 'styled-components'

import { Span } from '@/@bothrs-ui/web/components/typography/Body'

type Props = {
  date: Date
  signed?: boolean
}

export const DocumentSignState = ({ date, signed }: Props) => {
  const theme = useTheme()

  const color = signed ? theme.Colors.Status.Success : theme.Colors.Status.Warning

  const text = useMemo(() => {
    if (signed) {
      return t({
        id: 'signed.on',
        message: 'Ondertekend {date} om {time}',
        values: {
          date: format(date, 'd/MM/yyyy'),
          time: format(date, 'HH:mm'),
        },
      })
    }
    return t({
      id: 'to.sign.before',
      message: 'Te ondertekenen voor {date}',
      values: {
        date: format(date, 'd/MM/yyyy'),
      },
    })
  }, [signed, date])

  return (
    <Span type='BodyMediumRegular' color={color}>
      {text}
    </Span>
  )
}
